import { render, staticRenderFns } from "./businessReminderList.vue?vue&type=template&id=70134510&scoped=true"
import script from "./businessReminderList.vue?vue&type=script&lang=ts"
export * from "./businessReminderList.vue?vue&type=script&lang=ts"
import style0 from "./businessReminderList.vue?vue&type=style&index=0&id=70134510&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70134510",
  null
  
)

export default component.exports